import { api } from ".."

// função para pesquisar todas as ordens
const ApproversOrdersService = async (number: string, date: string, status: string, page: number, name: string) => {

    const response = await api.get('approvers/orders', {
        params: {
            number, date, status, page, name
        }
    });

    return response;

}
// função para pesquisar todas as ordens

// função para pesquisar dados de uma ordem
const ApproversShowOrderService = async (id: number) => {

    const response = await api.get(`approvers/orders/${id}`);

    return response;

}
// função para pesquisar dados de uma ordem

// função para pesquisar as ordens pendentes
const ApproversPendingOrdersService = async (number: string, date: string, page: number, name: string) => {

    const response = await api.get('approvers/orders/pending', {
        params: {
            number, date, page, name
        }
    });

    return response;

}
// função para pesquisar as ordens pendentes

export {
    ApproversOrdersService,
    ApproversShowOrderService,
    ApproversPendingOrdersService
}